/*=========================================================================================
  File Name: moduleAdminActions.js
  Description: Report Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
    fetchFileDownloadReport({ commit }, searchYear) {
        return new Promise((resolve, reject) => {
            axios.get('/api/user-report/file-download-count-by-month', { params: { searchYear: searchYear } })
                .then((response) => {
                    commit('SET_FILE_DOWNLOAD_COUNT_REPORT', response.data.resultBody)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    fetchFileStatistics({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('/api/user-report/file-statistics')
                .then((response) => {
                    commit('SET_FILE_STATISTICS', response.data.resultBody)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    fetchStreamingDurationReport({ commit }, searchYear) {
        return new Promise((resolve, reject) => {
            axios.get('/api/user-report/streaming-duration-by-month', { params: { searchYear: searchYear } })
                .then((response) => {
                    commit('SET_STREAMING_DURATION_REPORT', response.data.resultBody)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchSubscriptionReport({ commit }, searchYear) {
        return new Promise((resolve, reject) => {
            axios.get('/api/user-report/subscription-payment', { params: { searchYear: searchYear } })
                .then((response) => {
                    commit('SET_SUBSCRIPTION_REPORT', response.data.resultBody)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    fetchSubscriptionStatistics({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('/api/user-report/subscription-statistics')
                .then((response) => {
                    commit('SET_SUBSCRIPTION_STATISTICS', response.data.resultBody)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    fetchS3UsageReport({ commit }, searchYear) {
        return new Promise((resolve, reject) => {
            axios.get('/api/user-report/s3-usage-by-month', { params: { searchYear: searchYear } })
                .then((response) => {
                    commit('SET_S3_USAGE_REPORT', response.data.resultBody)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    fetchWowzaUsageReport({ commit }, searchYear) {
        return new Promise((resolve, reject) => {
            axios.get('/api/user-report/wowza-usage-by-month', { params: { searchYear: searchYear } })
                .then((response) => {
                    commit('SET_WOWZA_USAGE_REPORT', response.data.resultBody)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

}